// extracted by mini-css-extract-plugin
export default {"link":"AlbumContent_link__iCTuz","grid":"AlbumContent_grid__bLE4z"};